// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3T6sj","productName":"Table_productName__1yqQb"};